<!-- 福彩3D万能码6码走势图 -->
<template>
    <div class="">
        <div class="ssq-table">
            <div class="ssq-table-header">
                <div class="ssq-icon">
                    <svg t="1621310782405" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2538" width="45" height="45">
                        <path
                            d="M541.408711 157.6704h122.3936l44.347733-84.1216-199.529244-1.803378-266.146133 660.383289h63.644444z"
                            fill="#ffffff" p-id="2539"></path>
                        <path
                            d="M585.764978 271.402667h127.689955l44.828445-90.641067h-203.374934l-264.220444 666.843022h61.715911z"
                            fill="#ffffff" p-id="2540"></path>
                        <path
                            d="M813.343289 294.408533h-210.759111l-270.427022 657.846045h209.251555l90.643911-205.960534h126.2336s207.414044 9.910044 234.416356-232.490666c0 0 11.5712-160.924444-179.359289-219.394845z m1.823289 260.667734c-49.169067 80.275911-133.046044 52.315022-133.046045 52.315022l65.558756-159.647289c116.656356 6.764089 67.487289 107.335111 67.487289 107.332267zM203.901156 506.587022c40.4992-92.020622 128.253156-54.129778 128.253155-54.129778l69.415822-158.048711c0-14.819556-323.487289-52.562489-369.316977 239.246223-17.3568 176.822044 177.874489 204.694756 177.874488 204.694755l51.646578-119.893333c-96.079644-59.630933-57.873067-111.869156-57.873066-111.869156z"
                            fill="#ffffff" p-id="2541"></path>
                    </svg>
                    <div class="ssq-one">
                        <h2>中国福利彩票</h2>
                    </div>
                    <div class="ssq-two">
                        <h3>福彩 3 D 万 能 码 （六 码） 走 势 图</h3>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <table class="tab" border="1" cellspacing="0" cellpadding="0">
                <thead class="thead-fixed">
                    <tr>
                        <th rowspan="2" class="ranks_a ">期号</th>
                        <th rowspan="2" class="ranks_a1">开奖</th>
                        <th colspan="1" class="ranks_b" v-for="(item , i) in zu" :key="i">
                            {{item.data[0]}}{{item.data[1]}}{{item.data[2]}}{{item.data[3]}}{{item.data[4]}}{{item.data[5]}}
                        </th>
                        <th colspan="10" class="ranks_b">尾数走势图</th>
                        <th colspan="3" class="ranks_b">尾数012路</th>
                        <th colspan="3" class="ranks_b">尾数147路</th>
                        <th colspan="3" class="ranks_b">尾数258路</th>
                        <th colspan="2" class="ranks_b">奇 偶 </th>
                        <th colspan="2" class="ranks_b">大 小 </th>
                        <th colspan="2" class="ranks_b">质 合</th>
                        <th colspan="5" class="ranks_b">五行走势图</th>
                    </tr>

                    <tr>
                        <th class="ranks_c">01</th>
                        <th class="ranks_c">02</th>
                        <th class="ranks_c">03</th>
                        <th class="ranks_c">04</th>
                        <th class="ranks_c">05</th>
                        <th class="ranks_c">06</th>
                        <th class="ranks_c">07</th>
                        <th class="ranks_c">08</th>
                        <th class="ranks_c">09</th>
                        <th class="ranks_c">10</th>
                      

                        <th class="ranks_c">00</th>
                        <th class="ranks_c">01</th>
                        <th class="ranks_c">02</th>
                        <th class="ranks_c">03</th>
                        <th class="ranks_c">04</th>
                        <th class="ranks_c">05</th>
                        <th class="ranks_c">06</th>
                        <th class="ranks_c">07</th>
                        <th class="ranks_c">08</th>
                        <th class="ranks_c">09</th>

                        <th class="ranks_c">0</th>
                        <th class="ranks_c">1</th>
                        <th class="ranks_c">2</th>
                        <th class="ranks_c">1</th>
                        <th class="ranks_c">4</th>
                        <th class="ranks_c">7</th>
                        <th class="ranks_c">2</th>
                        <th class="ranks_c">5</th>
                        <th class="ranks_c">8</th>
                        <th class="ranks_c">奇</th>
                        <th class="ranks_c">偶</th>
                        <th class="ranks_c">大</th>
                        <th class="ranks_c">小</th>
                        <th class="ranks_c">质</th>
                        <th class="ranks_c">合</th>
                        <th class="ranks_c">金</th>
                        <th class="ranks_c">木</th>
                        <th class="ranks_c">水</th>
                        <th class="ranks_c">火</th>
                        <th class="ranks_c">土</th>


                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item2 ,x) in fc3d" :key='x'>
                        <td>{{item2.expect}}</td>
                        <td>
                            <div class="ranks_a12">
                                {{item2.red[0] }} {{item2.red[1] }} {{item2.red[2] }}
                            </div>
                        </td>
                        <td class="b-red" v-for="(item ,i) in q2" :key='i'>
                            <div :class="item==item1 ? 'q-red' : 'no' " v-for="(item1 ,j) in kai[x]" :key='j'>
                                {{item==item1 ? item : ''}}
                            </div>
                        </td>
                        <!-- 尾数 -->
                        <td class="b-lan" v-for="(item ,i) in q1" :key='i'>
                            <div :class="kai2[x][x,j]==item ? 'q-lan' : 'no' " v-for="(item1 ,j) in kai2[x]" :key='j'>
                                {{kai2[x][x,j]==item ? item : ''}}
                            </div>
                        </td>
                        <!-- 012路 -->
                        <td class="b-red" v-for="(item ,i) in lye" :key='i'>
                            <div :class=" item ==item1%10%3 ?'q-red':'no' " v-for="(item1 ,j) in lye1[x]" :key='j'>
                                {{ item ==item1%10%3 ?item:'' }}
                            </div>
                        </td>
                        <!-- 147路 -->
                        <td class="b-lan" v-for="(item ,i) in ysq" :key='i'>
                            <div :class="item == (([1,5,6,9].indexOf(item1)==-1 ? '' : 1)||
                            ([0,2,4].indexOf(item1)==-1 ? '' : 4)||([3,7,8].indexOf(item1)==-1 ? '' : 7) )
                            ? 'q-lan' : 'no'" v-for="(item1 ,j) in ysq1[x]" :key='j'>
                                {{ item == (([1,5,6,9].indexOf(item1)==-1 ? '' : 1)||
                                ([0,2,4].indexOf(item1)==-1 ? '' : 4)||([3,7,8].indexOf(item1)==-1 ? '' : 7) )
                                ? item : '' }}
                            </div>
                        </td>
                        <!-- 258路 -->
                        <td class="b-red" v-for="(item ,i) in ewb" :key='i'>
                            <div :class="item == (([2,7,9].indexOf(item1)==-1 ? '' : 2)||([0,3,5].indexOf(item1)==-1 ? '':5)||([1,4,6,8].indexOf(item1)==-1 ? '' : 8) ) ? 'q-red' : 'no'"
                                v-for="(item1 ,j) in ewb1[x]" :key='j'>
                                {{ item == (([2,7,9].indexOf(item1)==-1 ? '' : 2)||([0,3,5].indexOf(item1)==-1 ?
                                '':5)||([1,4,6,8].indexOf(item1)==-1 ? '' : 8) ) ? item : '' }}
                            </div>
                        </td>
                        <!-- 奇偶 -->
                        <td class="b-lan" v-for="(item ,i) in jo" :key='i'>
                            <div :class="item == item1? 'q-lan' : 'no'" v-for="(item1 ,j) in jo1[x]" :key='j'>
                                {{ item == item1? item : '' }}
                            </div>
                        </td>
                        <!-- 大小 -->
                        <td class="b-red" v-for="(item ,i) in dx" :key='i'>
                            <div :class="item == item1 ? 'q-red' : 'no'" v-for="(item1 ,j) in dx1[x]" :key='j'>
                                {{ item == item1 ? item : '' }}
                            </div>
                        </td>
                        <!-- 质合 -->
                        <td class="b-lan" v-for="(item ,i) in zh" :key='i'>
                            <div :class="item == item1 ? 'q-lan' : 'no' " v-for="(item1 ,j) in zh1[x]" :key='j'>
                                {{ item == item1 ? item : '' }}
                            </div>
                        </td>
                        <!-- 五行走势图 -->
                        <td class="b-red" v-for="(item ,i) in wx" :key='i'>
                            <div :class="item ==item1? 'q-red' : 'no'" v-for="(item1 ,j) in wx2[x]" :key='j'>
                                {{ item ==item1? item : '' }}
                            </div>
                        </td>

                    </tr>

                  
                    <tr>
                        <td>待开奖</td>
                        <td></td>
                        <td v-for="(x , i) in 40" :key='i'>
                            <div :class="x==i+1 ? 'xuan' : '' ">
                                {{"?"}}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>待开奖</td>
                        <td></td>
                        <td v-for="(x , i) in 40" :key='i'>
                            <div :class="x==i+1 ? 'xuan' : '' ">
                                {{"?"}}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>待开奖</td>
                        <td></td>
                        <td v-for="(x , i) in 40" :key='i'>
                            <div :class="x==i+1 ? 'xuan' : '' ">
                                {{"?"}}
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
      
    </div>
</template>

<script>
       import mitt from '@/js/mitt.js'
   
    //import '../js/font.js' //js文件引入，注意路径
    //import {myfun} from '../js/test.js' //js文件引入，注意路径
    //import Introduction from '@/views/Introduction.vue'
    //import api from '@/js/mpublic'
    export default {
        name: 'red-basic',
        components: {
          
        },
        data() { // 数据源
            return {
                q1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                q2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                kai: [],
                kai2: [],
                red0: [],
                lye: [0, 1, 2],
                lye1: [],
                ysq: [1, 4, 7],
                ysq1: [],
                ewb: [2, 5, 8],
                ewb1: [],
                jo: ["奇", "偶"],
                jo1: [],
                dx: ["大", "小"],
                dx1: [],
                zh: ["质", "合"],
                zh1: [],
                zf: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                wx2: [],
                wx: ['金', '木', '水', '火', '土'],
                zu: [
                    { data: [0, 1, 2, 3,4,6] },
                    { data: [0, 1, 2, 3,5,9] },
                    { data: [0, 1, 2,4,8,9] },
                    { data: [0, 1, 3,7,8,9] },
                    { data: [0, 2,6,7,8,9] },
                    { data: [0, 4,5,6,7,8] },
                    { data: [1,2,3,4,5,7] },
                    { data: [1,5,6,7,8,9] },
                    { data: [2,3,4,5,6,8] },
                    { data: [3,4,5,6,7,9] },

                ]
            }
        },
        mounted() {
            this.wnm()
            this.mlye()
            this.mysq()
            this.mewb()
            this.mjo()
            this.mdx()
            this.mzh()
            this.mwx()
            this.find()
        },
        computed: {
            fc3d() {
                return this.$store.state.fc3d;
            },
        },
        methods: { // 函数体部分，js的主要逻辑控制  
            find() {
                document.documentElement.scrollTop = 0;
                if(this.fc3d==''){
                    mitt.emit('fc3d');   
                }
            },
            wnm() {  //综合分布走势
                this.kai=[]
                this.kai2=[]
                for (var i = 0; i < this.fc3d.length; i++) {
                    var arr = new Array()
                    var arr2 = new Array()
                    for (var y = 0; y < this.zu.length; y++) {
                        //console.log(this.zu[y].data)
                        if (this.zu[y].data.indexOf(parseInt(this.fc3d[i].red[0])) > -1 && this.zu[y].data.indexOf(parseInt(this.fc3d[i].red[1])) > -1 && this.zu[y].data.indexOf(parseInt(this.fc3d[i].red[2])) > -1) {
                            arr.push(y + 1)//尾数未去重
                            if (arr2.indexOf((y + 1) % 10) == -1) {
                                arr2.push((y + 1) % 10)//尾数去重                              
                            }

                        }
                    }
                    this.kai.push(arr)
                    this.kai2.push(arr2)

                }
                // console.log(this.wx2)
                // console.log(this.kai2)
            },

            mlye() { //012路
                this.lye1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if (xx.indexOf(this.kai[i][i, j] % 10 % 3) == -1) {
                            xx.push(this.kai[i][i, j] % 10 % 3);
                        }
                    }
                    this.lye1.push(xx);
                }
                // console.log(this.lye1)
            },

            mysq() {  //147路
                this.ysq1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if (
                            this.kai[i][i, j] % 10 == 1 ||
                            this.kai[i][i, j] % 10 == 5 ||
                            this.kai[i][i, j] % 10 == 6 ||
                            this.kai[i][i, j] % 10 == 9
                        ) {
                            if (xx.indexOf(1) == -1) {
                                xx.push(1);
                            }
                        } else if (
                            this.kai[i][i, j] % 10 == 0 ||
                            this.kai[i][i, j] % 10 == 2 ||
                            this.kai[i][i, j] % 10 == 4
                        ) {
                            if (xx.indexOf(4) == -1) {
                                xx.push(4);
                            }
                        } else if (
                            this.kai[i][i, j] % 10 == 3 ||
                            this.kai[i][i, j] % 10 == 7 ||
                            this.kai[i][i, j] % 10 == 8
                        ) {
                            if (xx.indexOf(7) == -1) {
                                xx.push(7);
                            }
                        }
                    }
                    this.ysq1.push(xx);
                }
            },

            mewb() {  //258路
                this.ewb1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if (
                            this.kai[i][j] % 10 == 2 ||
                            this.kai[i][j] % 10 == 7 ||
                            this.kai[i][j] % 10 == 9
                        ) {
                            if (xx.indexOf(2) == -1) {
                                xx.push(2);
                            }
                        } else if (
                            this.kai[i][j] % 10 == 0 ||
                            this.kai[i][j] % 10 == 3 ||
                            this.kai[i][j] % 10 == 5
                        ) {
                            if (xx.indexOf(5) == -1) {
                                xx.push(5);
                            }
                        } else if (
                            this.kai[i][j] % 10 == 1 ||
                            this.kai[i][j] % 10 == 4 ||
                            this.kai[i][j] % 10 == 6 ||
                            this.kai[i][j] % 10 == 8
                        ) {
                            if (xx.indexOf(8) == -1) {
                                xx.push(8);
                            }
                        }
                    }
                    this.ewb1.push(xx);
                }
            },

            mjo() {  //奇偶
                this.jo1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if (this.kai[i][i, j] % 2 == 0) {
                            if (xx.indexOf("偶") == -1) {
                                xx.push("偶");
                            }
                        } else {
                            if (xx.indexOf("奇") == -1) {
                                xx.push("奇");
                            }
                        }
                    }
                    this.jo1.push(xx);
                }
            },

            mdx() {  //大小
                this.dx1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if (this.kai[i][i, j] % 10 < 5) {
                            if (xx.indexOf("小") == -1) {
                                xx.push("小");
                            }
                        } else {
                            if (xx.indexOf("大") == -1) {
                                xx.push("大");
                            }
                        }
                    }
                    this.dx1.push(xx);
                }
            },

            mzh() {  //质合
                this.zh1=[]
                for (var i = 0; i < this.kai.length; i++) {
                    var xx = new Array();
                    for (var j = 0; j < this.kai[i].length; j++) {
                        if ([1, 2, 3, 5, 7].indexOf(this.kai[i][i, j] % 10) == -1) {
                            if (xx.indexOf("合") == -1) {
                                xx.push("合");
                            }
                        } else {
                            if (xx.indexOf("质") == -1) {
                                xx.push("质");
                            }
                        }
                    }
                    this.zh1.push(xx);
                }
            },

            mwx() {//五行
                this.wx2=[]
                for (var i = 0; i < this.kai2.length; i++) {
                    var arr = new Array();
                    for (var j = 0; j < this.kai2[i].length; j++) {
                        if (this.kai2[i][i, j] == 1 || this.kai2[i][i, j] == 9) {
                            if (arr.indexOf('金') == -1) {
                                arr.push('金')
                            }
                        } if (this.kai2[i][i, j] == 2 || this.kai2[i][i, j] == 8) {
                            if (arr.indexOf('木') == -1) {
                                arr.push('木')
                            }
                        } if (this.kai2[i][i, j] == 3 || this.kai2[i][i, j] == 7) {
                            if (arr.indexOf('水') == -1) {
                                arr.push('水')
                            }
                        }if(this.kai2[i][i, j] == 4 || this.kai2[i][i, j] == 6){
                            if (arr.indexOf('火') == -1){
                                arr.push('火')
                            }   
                        }if(this.kai2[i][i, j] == 0 || this.kai2[i][i, j] == 5){
                            if (arr.indexOf('土') == -1){
                                arr.push('土')
                            }   
                        }

                    }

                    this.wx2.push(arr)

                    // console.log(this.kai2)
                }
            }



        },
        props: {

        },
        watch:{
            fc3d(){
                this.wnm()
            this.mlye()
            this.mysq()
            this.mewb()
            this.mjo()
            this.mdx()
            this.mzh()
            this.mwx()
            }
        }
    }
</script>

<style scoped>
    /* @import './swiper.css'; */
    .ssq-table-header {
        width: 100%;
        height: 50px;
        background-color: red;
    }

    .tab {
        margin: 0 auto;
        border-collapse: collapse;
    }

    .thead-fixed th {
        border: 1px solid #808080;
    }

    .ranks_a12 {
        width: 30px;
    }

    .ranks_c {

        width: 23px;
        color: red;
    }

    .ranks_d {
        width: 22px;
        color: blue;
    }

    .ssq-icon {
        text-align: left;
    }

    .icon {
        float: left;
    }

    .ssq-one {
        float: left;
        height: 42px;
        line-height: 42px;
        color: #fff;

    }

    .ssq-two {
        float: left;
        width: 80%;
        text-align: center;
        line-height: 42px;
        font-size: 25px;
        color: rgb(252, 251, 249);
    }

    .b-red {
        background-color: rgb(224, 191, 191);
    }

    .b-lan {
        background-color: #f8fcb2;
    }


    .q-red {
        background-color: rgb(87, 28, 114);
        border-radius: 15px;
        color: #fff;
    }

    .q-lan {
        background-color: #548ce0;
        border-radius: 15px;
        color: #fff;
    }

    .q-he {
        background-color: #22940b;
        border-radius: 15px;
        color: #fff;
    }

    tbody .xuan {
        background-color: rgb(160, 156, 156);
        border-radius: 15px;
        color: rgb(253, 253, 253);
    }

    .no {
        display: none;
    }
</style>